import {API} from "aws-amplify";
import {action, computed, observable, runInAction} from "mobx";
import {Contact} from "../models/contact";
import {Root} from "./store-root";

export class ContactStore {
    parent: Root;
    @observable Contacts = new Map();

    constructor(root: Root) {
        this.parent = root;
    }

    @action     LoadItems = async (keyword: string = '') => {
        if(keyword) {
            this.Contacts.clear();
            const fromBackend: Contact[] = await API.get('backend', `/contacts?keyword=${keyword}`, {});
            runInAction(() => {
                console.log('Contacts from backend ', fromBackend);
                fromBackend.forEach((item) => this.Contacts.set(item.Phone, item));

            })
        }
    }

    @computed get ItemsAsListOptions() {
        const contacts = Array.from(this.Contacts.values());
        console.log(contacts);
        const transformed = contacts.map((item: Contact) => {
            return {label: item.Name, key: item.Phone, value: item.Phone}
        })
        return transformed;
    }

    LoadContact = async (keyword: string) => {
        let found: Contact | undefined = undefined;
        await this.LoadItems(keyword);
        if (keyword) {
            const contacts: Contact[] = Array.from(this.Contacts.values());
            found = contacts.find((item) =>
                (item.Name.includes(keyword)
                    || item.Phone.includes(keyword)));
        }
        return found;
    }

}